export default __webpack_public_path__ + "static/media/paul-smith.1a32882b.jpg";